/**************************************************
 * Nombre:       Formacion_Perfil_Emprendimiento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import iso from "../../../Recursos/iso_azul.svg";
import {NEGRITA} from "../../../Constantes";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../../Dialogos/Dialogo_Wass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {RocketLaunch} from '@mui/icons-material'


const Formacion_Perfil_Emprendimiento = ({item}) => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Inciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >


                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 10}}
                    sx={{
                        backgroundColor: theme.palette.info.main,
                        py: 6,
                        px: sCell ? 4 : 6
                    }}
                >

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 9}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: sCell ? 40 : 48,
                                fontWeight: 600,
                                lineHeight: 1.1,
                                textAlign: sCell ? 'center' : 'left',
                                color: '#fff'
                            }}>

                                <RocketLaunch sx={{width: '2.5rem', height: '2.5rem', pr: 1, mt: 0.5, mb: -0.5,
                                    color: '#fff'}}/>
                                PERFIL DE EMPRENDIMIENTO
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'center', mt: 2}}>
                            <Typography sx={{fontSize: 18, fontWeight: 400, textAlign: 'center', lineHeight: 1.3,
                                color: '#fff'}}>
                                {item.perfilEmpre}
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <Button
                                onClick={() => abrir({asunto: `Pefil de emprendimiento ${item.nombre}`})}
                                color={'secondary'}
                                startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                                Mas informacion
                            </Button>
                        </Grid>


                    </Grid>


                </Grid>


            </Grid>

        </Grid>
    )

}
export default Formacion_Perfil_Emprendimiento

const items = [1, 2, 3]